<template>
  <div>
    <sub-menu
      :title="title"
      :routes="routes"
    ></sub-menu>

    <router-view></router-view>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu.vue'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      title: 'partners',
      routes: [
        { path: '/partner', title: 'overview' },
        { path: '/partner/marketing-material', title: 'marketing_material' },
      ]
    }
  },
  components: {
    SubMenu,
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },

}
</script>
